import { Modal, ModalFuncProps } from 'antd';
import { ButtonProps } from 'antd/es/button';
import { ExclamationCircleFilled } from '@ant-design/icons';

export interface ConfirmOptions {
  title?: string;
  content?: React.ReactNode;
  onOk?: () => Promise<void>;
  okText?: string;
  cancelText?: string;
  okType?: any;
  okButtonProps?: ButtonProps;
  icon?: React.ReactNode;
}

export type ConfirmInstance = ReturnType<typeof Modal.confirm>;

export type UseConfirmReturn = {
  confirm: (options: ConfirmOptions) => ConfirmInstance;
};

export const useConfirm = (): UseConfirmReturn => {
  const confirm = ({
    title = 'Are you sure?',
    content,
    onOk,
    okText = 'Yes',
    cancelText = 'Cancel',
    okType = 'primary',
    icon = <ExclamationCircleFilled />,
    okButtonProps = {},
  }: ConfirmOptions): ConfirmInstance => {
    let modal: ConfirmInstance | null = null;

    const config: ModalFuncProps = {
      title,
      content,
      icon,
      okText,
      okType,
      cancelText,
      okButtonProps: {
        ...okButtonProps,
        type: 'primary',
        loading: false,
      },
      async onOk() {
        try {
          modal?.update({
            okButtonProps: {
              ...okButtonProps,
              loading: true,
              disabled: true,
            },
          });

          await onOk?.();
        } catch (error) {
          modal?.update({
            okButtonProps: {
              ...okButtonProps,
              loading: false,
              disabled: false,
            },
          });
          throw error;
        }
      },
      onCancel() {
        modal?.destroy();
      },
    };

    modal = Modal.confirm(config);

    return modal;
  };

  return { confirm };
};
